<template>
  <!-- テキスト表示 & 画像 -->
  <div v-if="isSelect && isChallenge(act)" :id="index" :class="{ type1: !showText }" @click="clickImage($event)">
    <p><span v-html="getPopupTextElem(eText)" ></span></p>
    <div class="card">
      <div :class="{ correct: isCorrect, incorrect: isInCorrect }"></div>
        <div class="image" @touchstart="$emit('onTouchStart', act.image)" @touchend="$emit('onTouchEnd')" @touchmove="$emit('onTouchEnd')">
          <img :src="act.image">
          <button v-show="showVoice" class="icon-voice" @click="audioPlay(act.sounds[0])"></button>
        </div>
    </div>
  </div>
  <div v-else :id="index" :class="{ type1: !showText }" @click="childAudioPlay(act.sounds[0])">
    <p><span v-html="getPopupTextElem(eText)" ></span></p>
    <div class="card">
      <div :class="{ correct: isCorrect, incorrect: isInCorrect }"></div>
        <div class="image" @touchstart="$emit('onTouchStart', act.image)" @touchend="$emit('onTouchEnd')" @touchmove="$emit('onTouchEnd')">
          <img :src="act.image">
          <button v-show="showVoice" class="icon-voice" @click="audioPlay(act.sounds[0])"></button>
        </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import jquery from "jquery";
import * as constants from "@/mixin/constants";

export default {
  name: "A1act",
  props: {
    act: Object,
    answer: Object,
    questionState: String,
    challengeFillPolicy: String,
    index: Number,
    isSelect: Boolean,
    runmode: String
  },
  data() {
    return {
      // actのテキスト（英テキスト／日テキスト）
      eText: "",
      // テキスト表示するか否かを判断するフラグ
      showText: false,
      // 正解画像を表示するか否かを判断するフラグ
      isCorrect: false,
      // 不正解画像を表示するか否かを判断するフラグ
      isInCorrect: false,
      // 一度でもテキスト表示したか否かを判断するフラグ
      isDisp: false,
      // 再生アイコンを表示するか否かを判断するフラグ
      showVoice: false
    };
  },
  mixins: [
    common,
    runmode,
    audio,
    constants
  ],
  methods: {
    /**
     * 初期化処理
     */
    init: function() {
      this.log("A1act start init");

      // givenの場合は、問題データ／再生アイコンを表示する
      if (!this.isChallenge(this.act)) {
        this.isShowText();
        this.isDisp = true;
      }

      var iconVoice = $(".icon-voice");

      // 音声再生ボタンを無効にする
      iconVoice.addClass("disabled");
      $(iconVoice).prop("disabled", true);
    },
    /**
     * 画像押下処理
     */
    clickImage: function() {
      this.log("A1act start clickImage");

      const self = this;
      const targetID = "#" + this.index + " p";
      const eleS = $(".toparea-play .input");

      // 音声再生を停止してから、正解／不正解判定を行う。
      this.$emit("audioPause");

      if (this.answer.basicText == this.act.basicText) {
        // 正解の場合

        // 正解を親に通知
        this.$emit("isCorrect");

        // 正解音の再生
        this.audioCorrect();
        this.isAudioPlaying = false;
        // 正解画像の表示
        this.isCorrect = true;
        // 正解時アニメーション
        this.setAniTarget();
        this.Animate().then(function() {
          // テキスト表示するかを判定する
          if (self.challengeFillPolicy == "i") {
            self.isShowText();
            self.isDisp = true;
          }

          // 正解画像を非表示にする
          self.isCorrect = false;

          // aniTargetIDを削除する
          $(targetID).removeAttr("id");
          // 移動したテキストを再表示する
          eleS.removeClass("hide");

          // 親に通知する
          Vue.nextTick(function() {
            self.$emit("clickImage");
          });
        });
      } else {
        // 不正解の場合

        // 不正解を親に通知
        this.$emit("isInCorrect");

        // 不正解音の再生
        this.audioInCorrect();
        this.isAudioPlaying = false;
        // 不正解画像の表示
        this.isInCorrect = true;

        // 親に通知する
        this.setInterval(constants.INCORRECT_INTERVAL).then(function() {
          // 不正解画像を非表示にする
          self.isInCorrect = false;

          // 親に通知する
          Vue.nextTick(function() {
            self.$emit("clickImage");
          });
        });
      }
    },
    /**
     * 日本語訳の表示／全解答の表示を元に戻す
     */
    changeunDisp: function() {
      this.log("A1act start changeunDisp");

      var targetID = "#" + this.index + " p";
      var eleS = $(targetID);

      if (this.isDisp) {
        // 既に表示済みの場合は非表示にしない
        this.isShowText();
      } else {
        // 非表示に変更する
        eleS.css({
          background: "#D7DEE1",
          borderRadius: eleS.css("border-radius")
        });
        this.eText = "";
        this.showVoice = false;
      }
    },
    /**
     *  解答を日本語訳で表示する
     */
    changeDispJapanese: function() {
      this.log("A1act start changeDispJapanese");

      var targetID = "#" + this.index + " p";
      var eleS = $(targetID);
      eleS.css({
        background: "#FFFFFF",
        borderRadius: eleS.css("border-radius")
      });
      this.eText = this.act.japaneseText;
      this.showVoice = true;
    },
    /**
     *  解答を表示する
     */
    changeDispAnswer: function() {
      this.log("A1act start changeDispAnswer");

      var targetID = "#" + this.index + " p";
      var eleS = $(targetID);
      eleS.css({
        background: "#FFFFFF",
        borderRadius: eleS.css("border-radius")
      });
      this.eText = this.act.basicText;
      this.showVoice = true;
      this.showText = true;
    },
    /**
    /* 移動先のPタグに#aniTargetIDを付与する
     */
    setAniTarget: function() {
      this.log("A1act start setAniTarget");

      var targetID = "#" + this.index + " p";
      $(targetID).attr("id", "aniTarget");
    },
    /**
     * 正解時アニメーションを実行する
     */
    Animate: function() {
      this.log("A1act start Animate");

      const self = this;

      let answerText = this.act.basicText;

      let eleS = $(".toparea-play .input");
      let eleD = $("#aniTarget");
      let iconVoice = $(".toparea-play .icon-voice");

      let headerElem = $(".header");

      // 音声アイコンも非表示に
      iconVoice.addClass("hide");

      // 移動元の情報を取得
      let offsetTopS = eleS.offset().top;
      let offsetLeftS = eleS.offset().left;
      let eleWidthS = getComputedStyle(eleS.get(0), "").getPropertyValue("width");
      let eleHeightS = eleS.outerHeight();

      // 移動先の情報を取得
      let offsetTop = eleD.offset().top;
      let offsetLeft = eleD.offset().left;
      let eleWidth = getComputedStyle(eleD.get(0), "").getPropertyValue("width");
      let eleHeight = eleD.outerHeight();

      let fixedSize = this.$parent.getAutoAdjustFixedSize();

      return new Promise(function(resolve, reject) {
        // 移動元のstyleを変更
        eleS.removeClass("resetinput");
        eleS.css({
          top: offsetTopS,
          left: offsetLeftS,
          width: eleWidthS,
          height: eleHeightS
        });
        eleS.addClass("moveinput");

        let animateTop = offsetTop - headerElem.outerHeight();

        // 移動animate実行
        eleS.stop().animate({
          top: animateTop,
          left: offsetLeft,
          width: eleWidth,
          height: eleHeight,
          zIndex: 2
        }, 500, function() {
          if (!self.isEnvironmentPc()) {
            // テキストが収まるように自動調整
            eleS.textfill({
              minFontPixels: constants.AUTO_ADJUST_FONT_SIZE[self.textSize].min,
              maxFontPixels: fixedSize.cardAreaFontSize,
              allowOverflow: true
            });
          }
          setTimeout(function() {
            // 2. 移動元のstyleを初期値に戻し非表示に
            eleS.removeClass("moveinput");
            eleS.addClass("resetinput");
            eleS.addClass("hide");
            iconVoice.removeClass("hide");
            eleS.css({
              top: 0,
              left: 0,
              width: eleWidthS,
              height: eleHeightS
            });
            if (!self.isEnvironmentPc()) {
              eleS.children("span").css("font-size", fixedSize.topAreaFontSize);
            }

            resolve();
          }, 1000);
        });
      });
    },
    /**
     * テキスト表示するかを判定する
     */
    isShowText: function() {
      this.log("A1act start isShowText");

      var targetID = "#" + this.index + " p";
      var eleS = $(targetID);

      switch (this.runmode) {
        case constants.RUNMODE_A1:
        case constants.RUNMODE_A1O:
          this.changeDispAnswer();
          break;
        case constants.RUNMODE_B:
        case constants.RUNMODE_BO:
        case constants.RUNMODE_NR5:
          eleS.css({
            background: "#D7DEE1",
            borderRadius: eleS.css("border-radius")
          });
          this.eText = "";
          this.showVoice = true;
          break;
        default:
          break;
      }
    },
    /**
     * 音声再生アイコン表示中のitemの音声再生処理
     */
    childAudioPlay: function(sound) {
      // 音声再生アイコン非表示の場合は、音声再生しない
      if (!this.showVoice) {
        return;
      }
      var iconVoice = $(".icon-voice").attr("class");
      if (iconVoice.indexOf("disabled") == -1) {
        this.audioPlay(sound);
      }
    }
  },
  mounted: function() {
    this.init();
  },
  watch: {
    /**
     * 全問正解完了状態を監視する
     */
    questionState: function(newstatus) {
      this.log("A1act watch status");

      var eleS = $(".toparea-play .input");
      var iconVoice = $(".toparea-play .icon-voice");

      if (newstatus === "end") {
        this.changeDispAnswer();
        this.showVoice = true;

        // テキスト領域,再生アイコンを非表示に
        eleS.css("opacity", "0");
        iconVoice.addClass("hide");
      }
    },
    /**
     * ツールバー「日本語翻訳を表示する」の選択状態を監視する
     */
    dispJapaneseStatus: function(newstatus) {
      this.log("A1act watch dispJapaneseStatus");

      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.changeunDisp();
        }
      } else {
        this.changeDispJapanese();
      }
    },
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A1act watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.changeunDisp();
        }
      } else {
        this.changeDispAnswer();
      }
    },
    /**
    /* 音声再生状態を監視する
     */
    isAudioPlaying: function(newstatus) {
      this.log("A1act watch isAudioPlaying");

      var iconVoice = $(".icon-voice");

      if (this.isAudioPlaying) {
        // 音声再生ボタンを無効にする
        iconVoice.addClass("disabled");
        $(iconVoice).prop("disabled", true);
      } else {
        // 音声再生ボタンを有効にする
        iconVoice.removeClass("disabled");
        $(iconVoice).prop("disabled", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// A1act.vue?e0e384fc